import { render } from "./ReportHealth.vue?vue&type=template&id=2e262a28"
import script from "./ReportHealth.vue?vue&type=script&lang=js"
export * from "./ReportHealth.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Reports/ReportHealth.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2e262a28"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e262a28', __exports__)) {
    console.log('reload')
    api.reload('2e262a28', __exports__)
  }
  
  module.hot.accept("./ReportHealth.vue?vue&type=template&id=2e262a28", () => {
    console.log('re-render')
    api.rerender('2e262a28', render)
  })

}


export default __exports__